<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->
<div class="custom-field-list-input">
	<mat-extended-select
		class="full-width"
		ngDefaultControl
		name="customFieldDropdown"
		[formControl]="internalField"
		[placeholder]="customField.view.label"
		[includeFilter]="true"
		[required]="required"
		[multiSelect]="multiSelect"
		[option$]="option$"
		[sortCompareFunction]="compareUsingCustomFieldOrdinals"
		[includeNotSetOption]="!required"
		[isNotSetValid]="!required"
		[hint]="hint"
		[valuePath]="['value']"
	>
	</mat-extended-select>
</div>
